import BaseApi from '@/core/api/baseApi'

export interface NotificationData {
  recipient: string
  subject: string
  message: string
}

export default class NotificationsApi extends BaseApi {
  async sendNotification(data: NotificationData, projectCode: string): Promise<{ message: string }> {
    return this.post<{ message: string }, NotificationData>(`/api-admin/${projectCode}/notifications/send`,
      data
    )
  }
}

export const notificationsApi = BaseApi.createApiInstance(NotificationsApi)()